import React from "react";
import { createStyles, withStyles } from "@material-ui/core";

interface Props {
  label: string;
  classes: Record<string, string>;
}

const styles = createStyles({
  pill: {
    display: "inline-block",
    backgroundColor: "#FCE4EC",
    color: "#AD1457",
    borderRadius: 999,
    padding: "0.25rem 0.75rem",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.5,
    whiteSpace: "nowrap",
  },
});

const FrequencyPill = ({ label, classes }: Props) =>
  label ? <span className={classes.pill}>{label}</span> : null;

export default withStyles(styles)(FrequencyPill);
